import { Link } from "@inertiajs/react"

export function CategoryTabs({ categories, activeSlug = null, totalCount = 0, activeState = null }) {
  const stateParam = activeState ? `?state=${activeState}` : ""

  return (
    <div className="flex flex-wrap justify-center gap-2">
      {/* All Articles tab */}
      <Link
        href={`/collective${stateParam}`}
        className={`px-6 py-3 text-sm font-semibold uppercase tracking-wider transition-all ${
          activeSlug === null
            ? "bg-kf-gradient text-white"
            : "bg-white text-zinc-600 hover:text-kf-red border border-zinc-200"
        }`}
      >
        ALL
        <span className="ml-2 text-xs opacity-70">{totalCount}</span>
      </Link>

      {/* Category tabs */}
      {categories.map((category) => (
        <Link
          key={category.id}
          href={`/collective/${category.slug}${stateParam}`}
          className={`px-6 py-3 text-sm font-semibold uppercase tracking-wider transition-all ${
            activeSlug === category.slug
              ? "bg-kf-gradient text-white"
              : "bg-white text-zinc-600 hover:text-kf-red border border-zinc-200"
          }`}
        >
          {category.name}
          <span className="ml-2 text-xs opacity-70">{category.articleCount}</span>
        </Link>
      ))}
    </div>
  )
}
